import { Props } from './price';

export const RegularPrice = (_props: Props): null => null;
